import { MoreHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const stop = (e) => e.stopPropagation();

// 28x28 icon button with tooltip + aria-label; clicks never open the row
export function IconBtn({ icon: Icon, label, onClick, className = "", testid }) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button size="icon" variant="ghost" aria-label={label} className={`h-7 w-7 ${className}`} onClick={(e) => { stop(e); onClick?.(e); }} data-testid={testid}><Icon className="h-4 w-4" /></Button>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

// "⋯" menu with grouped items: groups = [[title, [[key, label, fn, testid]]]]; hidden when empty
export function MoreMenu({ groups, label = "More actions", testid }) {
  const gs = groups.filter(([, items]) => items.length);
  if (!gs.length) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="icon" variant="ghost" aria-label={label} title={label} className="h-7 w-7" onClick={stop} data-testid={testid}><MoreHorizontal className="h-4 w-4" /></Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" collisionPadding={8} className="max-w-[min(300px,90vw)]" onClick={stop}>
        {gs.map(([title, items], i) => (
          <div key={title}>
            {i > 0 && <DropdownMenuSeparator />}
            <DropdownMenuLabel className="text-[10px] uppercase tracking-wide text-slate-400">{title}</DropdownMenuLabel>
            {items.map(([key, l, fn, tid]) => <DropdownMenuItem key={key} onClick={fn} data-testid={tid}><span className="truncate" title={l}>{l}</span></DropdownMenuItem>)}
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
